import {
    createActionCreator,
    paramsEncode,
} from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
import {message} from "antd";

export const createLoadingAction = createActionCreator(constant.ListLoading, loading => loading); // 流加载
export const createHostListAction = createActionCreator(constant.GetList, list => list); // 列表
export const createHostListOldAction = createActionCreator(constant.GetListOld, list => list); // 列表
export const createHostAction = createActionCreator(constant.GETHOST, parmas => parmas);
export const createStatusAction = createActionCreator(constant.CHANGESTATUS, parmas => parmas);
export const createBulkStatusAction = createActionCreator(constant.CHANGEBULKSTATUS, parmas => parmas);
export const createAddListStatusAction = createActionCreator(constant.CHANGEADDLISTSTATUS, parmas => parmas);
export const createAddWorkListStatusAction = createActionCreator(constant.CHANGEADDWORKLISTSTATUS, parmas => parmas);
export const createSetIpListAction = createActionCreator(constant.IPLIST, list => list); // 设置ipList
export const createServerInfoAction = createActionCreator(constant.SERVERINFO, list => list);
export const changeServerStatus = createActionCreator(constant.SERVERSTATUS, parmas => parmas);
export const createPageAction = createActionCreator(constant.PAGETOTAL, page => page); // 存储总页数
export const searchDataAction = createActionCreator(constant.SEARCH, data => data);
export const createGetAutoCutHostTodayAction = createActionCreator(constant.GETTODAYM, obj => obj);
export const createGetAutoCutHostTodayStatusAction = createActionCreator(constant.GETTODAYMSTATUS, obj => obj);
export const createGetAutoCutHostToMorrowAction = createActionCreator(constant.GETTOMORROWM, obj => obj);
export const createGetAutoCutHostToMorrowStatusAction = createActionCreator(constant.GETTOMORROWMSTATUS, obj => obj);

export const restartServer = (f) => {
    const path = Urls.HostManageUrl.restartServer;
    return async (dispatch, getState) => {
        try {
            let path1 = path + "?f=" + f;
            let response = await request(path1);
            message.success(response);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createGetAutoCutHostTodayStatusAction(false));
        }
    };
};

export const getAutoCutHostToday = () => {
    const path = Urls.HostManageUrl.getAutoCutHostToday;
    return async (dispatch, getState) => {
        try {
            dispatch(createGetAutoCutHostTodayStatusAction(true));
            let response = await request(path);
            dispatch(createGetAutoCutHostTodayAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createGetAutoCutHostTodayStatusAction(false));
        }
    };
};

export const getAutoCutHostToMorrow = () => {
    const path = Urls.HostManageUrl.getAutoAddHostTomorrow;
    return async (dispatch, getState) => {
        try {
            dispatch(createGetAutoCutHostToMorrowStatusAction(true));
            let response = await request(path);
            dispatch(createGetAutoCutHostToMorrowAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createGetAutoCutHostToMorrowStatusAction(false));
        }
    };
};

export const setAutoCutHostToday = (params) => {
    const path = Urls.HostManageUrl.setAutoCutHostToday;
    return async (dispatch, getState) => {
        try {
            let path1 = path + "?flag=" + params;
            let response = await request(path1);
            // dispatch(createGetAutoCutHostTodayAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {

        }
    };
};

export const setAutoCutHostTomorrow = (params) => {
    const path = Urls.HostManageUrl.setAutoAddHostTomorrow;
    return async (dispatch, getState) => {
        try {
            let path1 = path + "?flag=" + params;
            let response = await request(path1);
            //  dispatch(createGetAutoCutHostTodayAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {

        }
    };
};

// 获取列表
export const getHostList = params => {
    return async (dispatch, getState) => {
        try {
            const pageParams = getState().hostList.pageTotal;
            const searchData = getState().hostList.searchData;
            const path = Urls.HostManageUrl.list + paramsEncode({...pageParams, ...searchData}).replace(/\&/, '?');
            dispatch(createLoadingAction(true));
            let response = await request(path);
            dispatch(createHostListAction(response.list));
            dispatch(createPageAction({total: response.total}));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

export const getServerInfo = () => {
    const path = Urls.HostManageUrl.getServerInfo;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(path);
            dispatch(createServerInfoAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

export const getHttpServerInfo = () => {
    const path = Urls.HostManageUrl.getHttpServerInfo;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(path);
            dispatch(createServerInfoAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};


// 修改服务管理
export const submitServerInfo = data => {
    return async (dispatch, getState) => {
        try {
            await request(Urls.HostManageUrl.modifyServerConfig, 'post', data);
        } catch (e) {
            throw new Error(e);
        } finally {

        }
    }
}

// 批量添加
export const addList = list => {
    return async (dispatch, getState) => {
        try {
            let str = Urls.HostManageUrl.addList;
            let result = await request(str, 'POST', list);
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
}


export const addWorkList = num => {
    return async (dispatch, getState) => {
        try {
            let str = Urls.HostManageUrl.addWorkList + "num=" + num;
            console.log('请求路径')
            let response = await request(str);
            message.success("调用成功,勿重复操作");
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
}

// 批量更新
export const bulkUpdate = bulk => {
    return async (dispatch, getState) => {
        try {
            let str = Urls.HostManageUrl.bulkUpdate;
            await request(str, 'post', bulk);
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
}

// 批量删除机器
export const bunchChangeStatus = (ids, type) => {
    return async (dispatch, getState) => {
        try {
            let str = Urls.HostManageUrl.bulkChangeSatus + '?type=' + type;
            await request(str, 'POST', ids);
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
}

// 删除主机
export const deleteHost = value => {
    const path = Urls.HostManageUrl.delete + '/?ip=' + value;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            await request(path);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

// 重启机器
export const restartHost = value => {
    const path = Urls.HostManageUrl.restart;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            await request(path, 'POST', value);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

// 重启worker
export const restartWorker = value => {
    const path = Urls.HostManageUrl.restartWorkers;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            await request(path, 'POST', value);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

// 修改主机
export const modifyHost = value => {
    const path = Urls.HostManageUrl.modify;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            await request(path, 'post', value);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};

// 新增主机
export const addHost = value => {
    const path = Urls.HostManageUrl.add;
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            await request(path, 'post', value);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};


export const againAllHostIndex = () => {
    return async (dispatch, getState) => {
        try {
            let url = Urls.HostManageUrl.againAllHostIndex
            await request(url);
            message.success("调用成功");
        } catch (e) {
            throw new Error(e);
        } finally {
        }
    }
}




// WEBPACK FOOTER //
// ./pages/assist/hostManage/actions.js